import { isNetworkError, isTimeoutError } from '@/utils/apiError';

// Timeout/network greška znači isto na svakoj auth formi (nema veze s
// poslužiteljem, ne s podacima koje je korisnik unio) — prije nego forma
// padne na svoju uobičajenu (formom-specifičnu) poruku, prvo provjeri je li
// uzrok zapravo konektivnost i prikaži to umjesto toga.
//
// isPaused pokriva poseban slučaj: React Query (networkMode: 'online',
// default) NE pokreće mutaciju uopće dok je navigator.onLine === false —
// mutacija ostaje "paused" (isPending i dalje true, isError još uvijek
// false) dok se veza ne vrati, tek onda stvarno šalje zahtjev. Bez ove
// provjere gumb bi samo beskonačno vrtio spinner bez ikakvog objašnjenja,
// jer axios-ov timeout nikad ne dobije priliku raditi — zahtjev nikad nije
// ni krenuo.
export const authErrorMessage = (
  error: unknown,
  isPaused: boolean,
  t: (key: string) => string,
  resolveFallback: () => string
): string => {
  if (isPaused) return t('errors.network.message');
  if (isTimeoutError(error)) return t('errors.timeout.message');
  if (isNetworkError(error)) return t('errors.network.message');
  return resolveFallback();
};
